export const InvoiceTypeConstants = {
  INVOICE_RENEWAL: 'c158bca3-e7b6-411d-89b0-1b1a3fb4dc08',
  GENERAL_ONCE_OFF: 'd6593b47-7e15-40c8-941c-1f695bad33ce',
  INVOICE_ONCE_OFF: '682ad4f0-1ca5-4c7a-b28c-a2258312b07f',
  SALES_ORDER_ONCE_OFF: '8ff2ecac-3b10-4c73-865d-cc3c6deefaf1',
  SALES_ORDER_RENEWAL: '3656bf64-cdd5-4d9f-98d4-f7cdbfb1d0e2',
} as const;

export type InvoiceTypeId =
  (typeof InvoiceTypeConstants)[keyof typeof InvoiceTypeConstants];
